"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoformatLists = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateList = require("@udecode/plate-list");
var _autoFormatUtils = require("./autoFormatUtils");
var autoformatLists = exports.autoformatLists = [{
  mode: 'block',
  type: _plateList.ELEMENT_LI,
  match: ['* ', '- '],
  preFormat: _autoFormatUtils.preFormat,
  format: function format(editor) {
    return (0, _autoFormatUtils.formatList)(editor, _plateList.ELEMENT_UL);
  }
}, {
  mode: 'block',
  type: _plateList.ELEMENT_LI,
  match: ['1. ', '1) '],
  preFormat: _autoFormatUtils.preFormat,
  format: function format(editor) {
    return (0, _autoFormatUtils.formatList)(editor, _plateList.ELEMENT_OL);
  }
}, {
  mode: 'block',
  type: _plateList.ELEMENT_TODO_LI,
  match: '[] '
}, {
  mode: 'block',
  type: _plateList.ELEMENT_TODO_LI,
  match: '[x] ',
  format: function format(editor) {
    return (0, _plateCommon.setNodes)(editor, {
      type: _plateList.ELEMENT_TODO_LI,
      checked: true
    }, {
      match: function match(n) {
        return (0, _plateCommon.isBlock)(editor, n);
      }
    });
  }
}];